import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "../data/site";

const LINKS = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/locations", label: "Locations" },
    { to: "/blog", label: "Intel" },
    { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    return (
        <header className="fixed top-0 inset-x-0 z-50 bg-[#07080B]/90 backdrop-blur-xl border-b border-white/10" data-testid="site-header">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link" onClick={() => setOpen(false)}>
                    <Logo size={36} />
                    <span className="leading-none">
                        <span className="block font-display font-extrabold uppercase tracking-wider text-lg text-white">Xtreme Protection</span>
                        <span className="block font-mono-xp text-[10px] tracking-[0.25em] text-[#E53E3E] uppercase mt-0.5">Scotland Security Services</span>
                    </span>
                </Link>
                <nav className="hidden md:flex items-center gap-8" data-testid="nav-desktop-menu">
                    {LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `font-mono-xp text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${
                                    isActive ? "text-[#E53E3E]" : "text-gray-400 hover:text-white"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <a
                        href={CONTACT.phoneHref}
                        data-testid="nav-phone-button"
                        className="xp-glow flex items-center gap-2 bg-[#E53E3E] hover:bg-[#c93636] transition-colors duration-300 text-white font-mono-xp text-xs uppercase tracking-widest px-5 py-2.5"
                    >
                        <Phone size={14} /> {CONTACT.phone}
                    </a>
                </nav>
                <button
                    className="md:hidden text-white p-2"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                    data-testid="nav-mobile-toggle"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>
            {open && (
                <nav className="md:hidden border-t border-white/10 bg-[#07080B] px-4 py-4 space-y-1" data-testid="nav-mobile-menu">
                    {LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            onClick={() => setOpen(false)}
                            data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                            className="block font-display uppercase tracking-wider text-xl text-gray-300 hover:text-[#E53E3E] py-2 transition-colors"
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <a href={CONTACT.phoneHref} data-testid="nav-mobile-phone-button" className="flex items-center gap-2 bg-[#E53E3E] text-white font-mono-xp text-xs uppercase tracking-widest px-4 py-3 mt-2">
                        <Phone size={14} /> {CONTACT.phone}
                    </a>
                </nav>
            )}
        </header>
    );
};
